module.exports = __webpack_public_path__ + "static/1-20ffd5859375bf3dab9a426db05e062c.jpg";